// ** IMPORTANT: This file now re-exports the jwtService from axios/index.js
// ** The actual jwtService instance is created in src/configs/axios/index.js
// ** with the proper axios instance to ensure interceptors work correctly

// Import the properly initialized jwtService from axios config
import { jwtService as configuredJwtService } from '@configs/axios'

// ** Export Service as useJwt
export default function useJwt(jwtOverrideConfig) {
  // If jwtOverrideConfig is provided, update the instance config
  if (jwtOverrideConfig) {
    configuredJwtService.jwtConfig = { ...configuredJwtService.jwtConfig, ...jwtOverrideConfig }
  }

  // Return the instance and expose its methods directly
  return {
    jwt: configuredJwtService,

    // Expose methods directly
    login: (...args) => configuredJwtService.login(...args),
    register: (...args) => configuredJwtService.register(...args),
    refreshToken: () => configuredJwtService.refreshToken(),
    getToken: () => configuredJwtService.getToken(),
    getRefreshToken: () => configuredJwtService.getRefreshToken(),
    setToken: (token) => configuredJwtService.setToken(token),
    setRefreshToken: (token) => configuredJwtService.setRefreshToken(token),

    // Expose the refreshTokenFailed property with a getter
    get refreshTokenFailed() {
      return configuredJwtService.refreshTokenFailed;
    }
  }
}

// Export the singleton instance for direct imports
export const jwtService = configuredJwtService;
